import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-arrow-left",
  "use": "ico-arrow-left-usage",
  "viewBox": "0 0 26.407 18.244",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26.407 18.244\" id=\"ico-arrow-left\">\n  <path id=\"ico-arrow-left_Path_1440\" data-name=\"Path 1440\" d=\"M0,0V24\" transform=\"translate(26.407 9.353) rotate(90)\" fill=\"none\" stroke=\"#4c6562\" stroke-width=\"2.5\" />\n  <path id=\"ico-arrow-left_Path_276\" data-name=\"Path 276\" d=\"M237.6,217.284l-8,8.294,8,8.21\" transform=\"translate(-227.68 -216.416)\" fill=\"none\" stroke=\"#4c6562\" stroke-width=\"2.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol